<h6 mat-dialog-title class="d-flex align-items-center mb-0">
  <mat-icon class="mr-2">keyboard_return</mat-icon>
  {{ 'inventory.popups.return.title' | translate }}
</h6>
<div class="popup-subtitle mb-1">
  {{ 'inventory.popups.return.subtitle' | translate }}
</div>
<mat-divider></mat-divider>

<mat-dialog-content>
  <form [formGroup]="ReturnAssetForm">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="fill">
          <mat-label
            >{{ 'inventory.popups.form.date' | translate
            }}{{ 'inventory.popups.return.title' | translate }}</mat-label
          >
          <input
            data-testid="notices_add_notice_input_end_date"
            type="text"
            placeholder="{{
              'inventory.add-edit.form.required.return_on_date' | translate
            }}"
            matInput
            [min]="minDate"
            formControlName="return_on_date"
            [matDatepicker]="pickerB"
            (click)="pickerB.open()"
            required
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerB"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerB></mat-datepicker>
          <mat-error>
            {{ 'inventory.add-edit.form.required.return_on_date' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="fill">
          <mat-label>
            {{ 'inventory.popups.return.remarks' | translate }}
          </mat-label>
          <input
            type="text"
            matInput
            formControlName="remarks"
            [placeholder]="translate.instant('inventory.popups.return.remarks')"
            required
            maxlength="50"
          />
          <mat-error>{{
            'inventory.add-edit.form.required.remarks' | translate
          }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div *ngIf="!isView">
    <button
      mat-flat-button
      color="primary"
      (click)="onReturn()"
      [disabled]="this.ReturnAssetForm.invalid"
    >
      {{ 'inventory.add-edit.form.save' | translate }}
    </button>
  </div>

  <button mat-flat-button class="button-style" (click)="onClose()">
    Cancel
  </button>
</mat-dialog-actions>
